import { cloneDeep, constant, forEach } from 'lodash';
import { format } from 'url';
import { getLineAxisPointer, getShadowAxisPointer, getCrossAxisPointer } from './axisPointer'
import { format as timeformat } from "date-fns";
import { isNil } from 'lodash'
import { element } from 'protractor';
import { EChartOption } from 'echarts'
import * as _ from 'lodash';
/**
 * 已废弃
 * @deprecated
 */
export const columnChart_tooTip = {
    show: true,
    trigger: 'axis',
    axisPointer: {
        type: 'shadow',
        axis: 'auto',
    },
    borderColor: '#7CB5EC',
    borderWidth: 1,
    backgroundColor: 'rgba(247, 247, 247, 0.85)',
    extraCssText: 'box-shadow: 0 0 3px rgba(0, 0, 0, 0.3);border-radius:4px',
    textStyle: {
        color: "#333333",
        fontSize: 11
    },
    padding: 8,
    formatter: (param) => {

        let str = '';
        // let tooltipUnit = 'mm';    //替换 tooltip里显示的单位
        if (param.length > 0) {
            str = '<span>' + param[0].name + '<span><br/>'
            param.forEach(element => {
                str += '<span style="color:' + element.color + '">' + element.seriesName + '：</span> <b>' + element.value + '</b><br/>'
            });
        }

        return str;
    }
}

export const getToolTipOfAxisChart = function (style: any, unit: string, sName?): any {
    let paramJsonObj = {
        trigger: "axis",
        transitionDuration: 0,
        appendToBody: true,
        confine: true, //是否将 tooltip 框限制在图表的区域内
        enterable: true,
        axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "line",
            snap: true,
            label: {
                show: true,
            }, // 默认为直线，可选为：'line' | 'shadow'
        },
        borderColor: "#7CB5EC",
        borderWidth: 1,
        // backgroundColor: "#F7F7F7",
        backgroundColor: 'rgba(247, 247, 247, 0.85)',
        extraCssText: "box-shadow: 0 0 3px rgba(0, 0, 0, 0.3); borderRadius: 3; max-height: 400px;overflow: auto;font-size: 12px;",
        textStyle: {
            color: "#333333",
            fontSize: 12,
        },
        padding: 6,
        formatter: (params) => {

            // let str = "<div class='tool-tip'>";
            let str = "";
            //   let unit = "℃"; //替换 tooltip里显示的单位
            if (params.length > 0) {
                // console.log("params", params);
                str += "<span>" + params[0].name + "<span><br/>";
                params.forEach((element) => {
                    let units = sName && sName.length != 0 ? sName[element.seriesIndex] : "";
                    if (isNil(element.data)) {
                        str += '<span style="display:inline-block;margin-right:5px;border-radius:8px;width:8px;height:8px;background-color:' + element.color + ';"></span>';
                        str += '<span style="color:' + element.color + ';">' + element.seriesName + "：</span> <b>" + "--" + " " + unit + units + "</b><br/>";
                    } else {
                        str += '<span style="display:inline-block;margin-right:5px;border-radius:8px;width:8px;height:8px;background-color:' + element.color + ';"></span>';
                        str += '<span style="color:' + element.color + ';">' + element.seriesName + "：</span> <b>" + element.data + " " + unit + units + "</b><br/>";
                    }
                });
            }
            return str;
        },
    }
    return paramJsonObj;
}

export const getTooltipOfAxisChartWithMultiDimension = function (unit: string[]) {
    let paramJsonObj = {
        trigger: "axis" as 'item' | 'axis' | 'none',
        transitionDuration: 0,
        // appendToBody: true,
        confine: true, //是否将 tooltip 框限制在图表的区域内
        enterable: true,
        axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "line" as | "line" | 'shadow' | 'none' | 'cross',
            snap: true,
            label: {
                show: true,
            }, // 默认为直线，可选为：'line' | 'shadow'
        },
        borderColor: "#7CB5EC",
        borderWidth: 1,
        backgroundColor: 'rgba(247, 247, 247, 0.85)',
        extraCssText: "box-shadow: 0 0 3px rgba(0, 0, 0, 0.3); borderRadius: 3; max-height: 400px;overflow: auto;font-size: 12px;",
        textStyle: {
            color: "#333333",
            fontSize: 12,
        },
        padding: 6,
        formatter: (params) => {

            let str = "";
            if (params.length > 0) {
                str += "<span>" + params[0].name + "<span><br/>";
                params.forEach((element) => {
                    if (Array.isArray(element.data) && Array.isArray(element.dimensionNames)) {
                        for (let i = 0; i < element.dimensionNames.length - 1; i++) {
                            if (isNil(element.value[i + 1])) {
                                str += '<span style="display:inline-block;margin-right:5px;border-radius:8px;width:8px;height:8px;background-color:' + element.color + ';"></span>';
                                // str += '<span style="color:' + element.color + ';">' + element.seriesName + "：</span> <b>" + "--" + " " + unit + "</b><br/>";
                                str += element.seriesName + "：<b>" + "--" + " " + unit + "</b><br/>";
                            } else {
                                str += '<span style="display:inline-block;margin-right:5px;border-radius:8px;width:8px;height:8px;background-color:' + element.color + ';"></span>';
                                // str += '<span style="color:' + element.color + ';">' + element.seriesName + '-' + element.dimensionNames[i + 1] + "：</span> <b>" + element.value[i + 1] + " " + unit[i] + "</b><br/>";
                                str += element.seriesName + element.dimensionNames[i + 1] + "：<b>" + element.value[i + 1] + " " + unit[i] + "</b><br/>";
                            }
                        }
                    } else {
                        if (isNil(element.value)) {
                            str += '<span style="display:inline-block;margin-right:5px;border-radius:8px;width:8px;height:8px;background-color:' + element.color + ';"></span>';
                            str += element.seriesName + "：<b>" + "--" + " " + unit + "</b><br/>";
                        } else {
                            str += '<span style="display:inline-block;margin-right:5px;border-radius:8px;width:8px;height:8px;background-color:' + element.color + ';"></span>';
                            str += element.seriesName + "：<b>" + element.value + " " + unit + "</b><br/>";
                        }
                    }
                });
            }
            return str;
        }
    }
    return paramJsonObj;
}
// 获取默认tooltip axis
export const getDefaultToolTipOfAxisChart = function (unit: string = ''): any {
    let paramJsonObj = {
        trigger: "axis",
        transitionDuration: 0,
        appendToBody: true,
        // confine: true, //是否将 tooltip 框限制在图表的区域内
        enterable: true,
        axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "line",
            snap: true,
            label: {
                show: true,
            }, // 默认为直线，可选为：'line' | 'shadow'
        },
        borderColor: "#7CB5EC",
        borderWidth: 1,
        backgroundColor: 'rgba(247, 247, 247, 0.85)',
        extraCssText: "box-shadow: 0 0 3px rgba(0, 0, 0, 0.3); borderRadius: 3; max-height: 400px;overflow: auto;font-size: 12px;",
        textStyle: {
            color: "#333333",
            fontSize: 12,
        },
        padding: 6,
        formatter: (params) => {
            let str = "";
            if (params.length > 0) {
                str += "<span>" + params[0].name + "<span><br/>";
                params.forEach((element) => {
                    if (isNil(element.data)) {
                        str += '<span style="display:inline-block;margin-right:5px;border-radius:8px;width:8px;height:8px;background-color:' + element.color + ';"></span>';
                        str += '<span style="color:' + element.color + ';">' + element.seriesName + "：</span> <b>" + "--" + " " + unit + "</b><br/>";
                    } else {
                        str += '<span style="display:inline-block;margin-right:5px;border-radius:8px;width:8px;height:8px;background-color:' + element.color + ';"></span>';
                        str += '<span style="color:' + element.color + ';">' + element.seriesName + "：</span> <b>" + element.data + " " + unit + "</b><br/>";
                    }
                });
            }
            return str;
        },
    }
    return paramJsonObj;
}
export const getToolTipOfAxisChart2 = function (style: any, unit: string): any {
    let paramJsonObj = {
        trigger: "axis",
        transitionDuration: 0,
        appendToBody: true,
        confine: true, //是否将 tooltip 框限制在图表的区域内
        enterable: true,
        axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "line",
            snap: true,
            label: {
                show: true,
            }, // 默认为直线，可选为：'line' | 'shadow'
        },
        borderColor: "#7CB5EC",
        borderWidth: 1,
        // backgroundColor: "#F7F7F7",
        backgroundColor: 'rgba(247, 247, 247, 0.85)',
        extraCssText: "box-shadow: 0 0 3px rgba(0, 0, 0, 0.3); borderRadius: 3; max-height: 400px;overflow: auto;font-size: 12px;",
        textStyle: {
            color: "#333333",
            fontSize: 12,
        },
        padding: 6,
        formatter: (params) => {
            // console.log("params", params);
            // let str = "<div class='tool-tip'>";
            let str = "";
            //   let unit = "℃"; //替换 tooltip里显示的单位

            if (params.length > 0) {
                str += "<span><b>" + params[0].data[0] + "<span></b><br/>";
                params.forEach((element) => {
                    str += '<span style="display:inline-block;margin-right:5px;border-radius:8px;width:8px;height:8px;background-color:' + element.color + ';"></span>';
                    str += '<span style="color:' + element.color + ';">' + element.seriesName + "：</span> <b>" + element.data[1] + " " + unit + "</b><br/>";
                });
            }
            return str;
        },
    }
    return paramJsonObj;
}

export const getToolTipOfAxisChartNoXaxisData = function (style: any, unit: string): any {
    let paramJsonObj = {
        trigger: "axis",
        transitionDuration: 0,
        confine: true, //是否将 tooltip 框限制在图表的区域内
        enterable: true,
        appendToBody: true,
        axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "line",
            snap: true,
            label: {
                show: true,
            }, // 默认为直线，可选为：'line' | 'shadow'
        },
        borderColor: "#7CB5EC",
        borderWidth: 1,
        // backgroundColor: "#F7F7F7",
        backgroundColor: 'rgba(247, 247, 247, 0.85)',
        extraCssText: "box-shadow: 0 0 3px rgba(0, 0, 0, 0.3); borderRadius: 3; max-height: 400px;overflow: auto;font-size: 12px;",
        textStyle: {
            color: "#333333",
            fontSize: 12,
        },
        padding: 6,
        formatter: (params) => {
            // console.log("params", params);
            // let str = "<div class='tool-tip'>";
            let str = "";
            //   let unit = "℃"; //替换 tooltip里显示的单位
            if (params.length > 0) {
                str += "<span>" + params[0].data[0] + "<span><br/>";
                params.forEach((element) => {
                    str += '<span style="display:inline-block;margin-right:5px;border-radius:8px;width:8px;height:8px;background-color:' + element.color + ';"></span>';
                    str += '<span style="color:' + element.color + ';">' + element.seriesName + "：</span> <b>" + element.data[1] + " " + unit + "</b><br/>";
                });
            }
            return str;
        },
    }
    return paramJsonObj;
}

export const getToolTipOfItemChart = function (style: any, unit: string = ""): any {
    let paramJsonObj = {
        trigger: "item",
        transitionDuration: 0,
        confine: true, //是否将 tooltip 框限制在图表的区域内
        borderColor: "#7CB5EC",
        borderWidth: 1,
        // backgroundColor: "#F7F7F7",
        backgroundColor: 'rgba(247, 247, 247, 0.85)',
        extraCssText: "box-shadow: 0 0 3px rgba(0, 0, 0, 0.3); borderRadius: 3;",
        textStyle: {
            color: "#333333",
            fontSize: 12,
        },
        padding: 6,
        formatter: (param) => {
            let str = "<span >" + param.name + "<span><br/>";
            str +=
                '<span style="display:inline-block;margin-right:5px;border-radius:8px;width:8px;height:8px;background-color:' +
                param.color +
                ';"></span>';
            str +=
                '<span style="color:' +
                param.color +
                '">' +
                param.seriesName +
                "：</span> <b>" +
                (param.value == null ? '--' : param.value) +
                unit +
                "</b><br/>";
            return str;
        },
    }
    return paramJsonObj;
}

export const getToolTipOfItemChartTranslation = function (style: any, unit: string = "", translationNumber: number = 0): any {
    let paramJsonObj = {
        trigger: "item",
        transitionDuration: 0,
        confine: true, //是否将 tooltip 框限制在图表的区域内
        appendToBody: true,
        borderColor: "#7CB5EC",
        borderWidth: 1,
        // backgroundColor: "#F7F7F7",
        backgroundColor: "rgba(247, 247, 247, 0.85)",
        extraCssText: "box-shadow: 0 0 3px rgba(0, 0, 0, 0.3); borderRadius: 3;",
        textStyle: {
            color: "#333333",
            fontSize: 12,
        },
        padding: 6,
        formatter: (param) => {
            let value = (+param.value[1] + translationNumber).toFixed(1);
            let str = "<span >" + param.name + "<span><br/>";
            str +=
                '<span style="display:inline-block;margin-right:5px;border-radius:8px;width:8px;height:8px;background-color:' +
                param.color +
                ';"></span>';
            str +=
                '<span style="color:' +
                param.color +
                '">' +
                param.seriesName +
                "：</span> <b>" +
                value +
                unit +
                "</b><br/>";
            return str;
        },
    }
    return paramJsonObj;
}

/**
 * 获取axis tooltip
 * @param tooltipUnit 单位
 * @param formatter 回调
 */
export function getCommonTooltipOfAxis(tooltipUnit: string | string[] = "", formatter: any = "", xAxisTooltip?: { data: string, unit: string }[]) {

    const commonTooltip = {
        show: true,
        confine: true,
        // enterable: true,
        // appendToBody: true,
        trigger: 'axis',
        axisPointer: getShadowAxisPointer(),
        borderColor: '#7CB5EC',
        borderWidth: 1,
        backgroundColor: 'rgba(247, 247, 247, 0.85)',
        extraCssText: 'box-shadow: 0 0 3px rgba(0, 0, 0, 0.3);border-radius:4px',
        textStyle: {
            color: "#333333",
            fontSize: 12
        },
        padding: 8,
        formatter: function (params) {
            let str = '';
            if (params.length > 0) {
                str = '<span>' + params[0].name + '<span><br/>'
                if (Array.isArray(tooltipUnit)) {
                    params.forEach((element, index) => {
                        if (isNil(element.value)) {
                            str += '<span style="color:' + element.color + '">' + element.marker + element.seriesName + '：</span> <b>' + "--" + ' ' + tooltipUnit[index] + '</b><br/>'

                        } else {
                            str += '<span style="color:' + element.color + '">' + element.marker + element.seriesName + '：</span> <b>' + element.value + ' ' + tooltipUnit[index] + '</b><br/>'
                        }
                    });
                } else {
                    params.forEach(element => {
                        if (isNil(element.value)) {
                            str += '<span style="color:' + element.color + '">' + element.marker + element.seriesName + '：</span> <b>' + "--" + ' ' + tooltipUnit + '</b><br/>'
                        } else {
                            str += '<span style="color:' + element.color + '">' + element.marker + element.seriesName + '：</span> <b>' + element.value + ' ' + tooltipUnit + '</b><br/>'
                        }
                    });
                }
            }
            return str;
        }
    }
    if (formatter != '') {
        const option = cloneDeep(commonTooltip)
        option.formatter = formatter
        return option;
    }

    if (!_.isNil(xAxisTooltip)) {
        const tooltipOption = cloneDeep(commonTooltip)
        tooltipOption.formatter = (params): string => {
            let str = '';
            if (params.length > 0) {
                str = '<span>' + params[0].name + '<span><br/>'
                for (let i = 0; i < params.length; i++) {
                    for (let j = 0; j < xAxisTooltip.length; j++) {

                        if (params[i].axisValue == xAxisTooltip[j].data) {
                            if (params[i].value == null) {
                                str += '<span style="color:' + params[i].color + '">'
                                    + params[i].marker + params[i].seriesName + '：</span> <b>' + '--' + ' '
                                    + xAxisTooltip[j].unit + '</b><br/>'
                            } else {
                                str += '<span style="color:' + params[i].color + '">'
                                    + params[i].marker + params[i].seriesName + '：</span> <b>' + params[i].value + ' '
                                    + xAxisTooltip[j].unit + '</b><br/>'
                            }
                        }
                    }
                }
            }
            return str;
        }
        return tooltipOption;
    }

    return commonTooltip;
}

/**
 * 获取item tooltip
 * @param tooltipUnit 单位
 * @param formatter 回调函数
 */
export function getCommonTooltipOfItem(tooltipUnit: string = "", formatter?: string | ((params: any) => string)) {
    const commonTooltip: { [k: string]: any } = {
        show: true,
        trigger: 'item',
        confine: true,
        borderColor: '#7CB5EC',
        borderWidth: 1,
        backgroundColor: 'rgba(247, 247, 247, 0.85)',
        extraCssText: 'box-shadow: 0 0 3px rgba(0, 0, 0, 0.3);border-radius:4px',
        textStyle: {
            color: "#333333",
            fontSize: 12
        },
        padding: 8,
        formatter: function (params) {
            let str = '';
            str = '<span>' + params.name + '<span><br/>'
            str += '<span style="color:' + params.color + '">' + params.marker + params.seriesName + '：</span> <b>' + params.value + tooltipUnit + '</b><br/>'
            return str;
        }
    }
    if (formatter) {
        commonTooltip.formatter = formatter;
    }

    return commonTooltip;
}

export function getPyramidChartTooltip(tooltipUnit?: string, formatter?: string | ((...args: any) => string)) {
    const pyramidChartTooltip: { [k: string]: any } = {
        show: true,
        trigger: 'item',
        confine: true,
        borderColor: '#7CB5EC',
        borderWidth: 1,
        backgroundColor: 'rgba(247, 247, 247, 0.85)',
        extraCssText: 'box-shadow: 0 0 3px rgba(0, 0, 0, 0.3);border-radius:4px',
        textStyle: {
            color: "#333333",
            fontSize: 12
        },
        padding: 8,
        formatter: (params: any): string => {
            let str = '';

            str = '<span>' + params.name + '</span><br/>';
            str += '<span style="color:' + params.color + '">' + params.marker + params.seriesName + ': </span> <b>' + Math.abs(params.value) + tooltipUnit + '</b><br/>';
            return str;
        }
    }
    if (formatter) {
        pyramidChartTooltip.formatter = formatter;
    }

    return pyramidChartTooltip;

}

export function getTooltipOfPieChart(style) {
    const pieChartTooltip = {
        show: true,
        trigger: 'item',
        // confine: true,
        // appendToBody: true,
        borderColor: '#7CB5EC',
        borderWidth: 1,
        backgroundColor: 'rgba(247, 247, 247, 0.85)',
        extraCssText: 'box-shadow: 0 0 3px rgba(0, 0, 0, 0.3);border-radius:4px',
        textStyle: {
            color: "#333333",
            fontSize: 12
        },
        padding: 8,
        position: (point, param, dom, rect, size) => {
            return [point[0] - dom.offsetWidth / 2, point[1] - dom.offsetHeight - 10]
        },
        formatter: function (params) {
            let str = '';
            str = '<span>' + params.seriesName + '<span><br/>'
            str += '<span style="color:' + params.color + '">' + params.marker + params.name + '：</span> <b>' + params.percent.toFixed(1) + '% </b><br/>'
            return str;
        }
    }
    return pieChartTooltip;
}

// timeline地图 area模式(整个行政区)
export function getTooltipOfAreaMap(tooltipUnit: string | string[] = "") {
    const areaMapTooltip = {
        show: true,
        trigger: 'item',
        borderColor: '#7CB5EC',
        borderWidth: 1,
        backgroundColor: 'rgba(247, 247, 247 ,0.85)',
        extraCssText: 'box-shadow: 0 0 3px rgba(0, 0, 0, 0.3);border-radius:4px',
        textStyle: {
            color: "#333",
            fontSize: 12,
        },
        padding: 8,
        formatter: function (params) {
            params.value = params.value ? params.value : '-'

            let str = '';
            str = '<span>' + params.name + '<span><br/>'
            if (typeof (tooltipUnit) == 'string') {
                str += '<span style="color:' + params.color + '">' + params.marker + params.seriesName + '：</span> <b>' + params.value + ' ' + tooltipUnit + '</b><br/>'
            } else if (Array.isArray(tooltipUnit)) {
                for (let i = 0; i < tooltipUnit.length; i++) {
                    let value = params.data ? params.data.value[i] : '-';
                    if (params.data) {
                        if (params.data.hasOwnProperty('value') && params.data.value[i]) {
                            value = params.data.value[i]
                        } else {
                            value = '-'
                        }
                    } else {
                        value = '-'
                    }

                    str += '<span style="color:' + params.color + '">' + params.marker + params.dimensionNames[i] + '：</span> <b>' + value + ' ' + tooltipUnit[i] + '</b><br/>'
                }
            }

            return str;
        }
    }
    return areaMapTooltip;
}
// timeline地图 point模式
export function getTooltipOfPointMap(tooltipUnit: string | string[] = "") {
    const pointMapTooltip = {
        show: true,
        trigger: 'item' as 'item' | 'axis' | 'none',
        // appendToBody: true,
        borderColor: '#7CB5EC',
        borderWidth: 1,
        backgroundColor: 'rgba(247, 247, 247, 0.85)',
        extraCssText: 'box-shadow: 0 0 3px rgba(0, 0, 0, 0.3);border-radius:4px',
        textStyle: {
            color: "#333333",
            fontSize: 12,
            lineHeight: 18
        },
        padding: 8,
        formatter: function (params) {
            params.value = params.value ? params.value : '-'
            let str = '';
            str = '<span>' + params.name + '<span><br/>'
            if (typeof (tooltipUnit) == 'string') {
                str += '<span style="color:' + params.color + '">' + params.marker + params.seriesName + '：</span> <b>' + (params.value == '-99' || params.value == null ? '--' : params.value) + ' ' + tooltipUnit + '</b><br/>'
            } else if (Array.isArray(tooltipUnit)) {
                for (let i = 0; i < tooltipUnit.length; i++) {
                    if (isNil(params.value[i + 2])) {
                        params.value[i + 2] = '-';
                    }
                    if (params.value[2] == -1) {
                        params.value[2] = '-'
                    }
                    str += '<span style="color:' + params.color + '">' + params.marker + params.dimensionNames[i + 2] + '：</span> <b>' + (params.value[i + 2] == '-99' || params.value[i + 2] == null ? '--' : params.value[i + 2]) + ' ' + tooltipUnit[i] + '</b><br/>'
                }
            }

            return str;
        }
    }
    return pointMapTooltip;
}

// timeline tooltip
export function getTooltipOfTimeline() {
    let timelineTooltip = {
        show: true,
        trigger: 'item',
        borderColor: '#7CB5EC',
        borderWidth: 1,
        backgroundColor: 'rgba(247, 247, 247 ,0.85)',
        extraCssText: 'box-shadow: 0 0 3px rgba(0, 0, 0, 0.3);border-radius:4px',
        textStyle: {
            color: "#333",
            fontSize: 12,
        },
        padding: 8,
        formatter: function (params) {
            params.value = params.value ? params.value : '-'
            let str = '';
            str += '<span style="color:' + params.color + '">' + params.marker + params.name + '</span><br/>'
            return str;
        }

    }
    return timelineTooltip;
}

export function getNoiseAnalysisLineTooltip(formatter?) {
    const tooltip = {
        trigger: 'axis',
        transitionDuration: 0,
        appendToBody: true,
        confine: true, //!是否将 tooltip 框限制在图表的区域内
        enterable: true,
        borderColor: '#7CB5EC',
        borderWidth: 1,
        backgroundColor: 'rgba(247, 247, 247, 0.85)',
        extraCssText: "box-shadow: 0 0 3px rgba(0, 0, 0, 0.3); borderRadius: 3; max-height: 240px;overflow: auto;font-size: 12px;",
        textStyle: {
            color: "#333333",
            fontSize: '100%'
        },
        padding: 6,
        // hideDelay: 500,
        formatter: formatter,
        axisPointer: getShadowAxisPointer()
    }
    return tooltip;
}

export function getNoiseDropLineTooltip(formatter?) {
    const tooltip = {
        trigger: 'axis',
        transitionDuration: 0,
        appendToBody: true,
        confine: true, //!是否将 tooltip 框限制在图表的区域内
        enterable: true,
        borderColor: '#7CB5EC',
        borderWidth: 1,
        backgroundColor: 'rgba(247, 247, 247, 0.85)',
        extraCssText: "box-shadow: 0 0 3px rgba(0, 0, 0, 0.3); borderRadius: 3; max-height: 240px;overflow: auto;font-size: 12px;",
        textStyle: {
            color: "#333333",
            fontSize: '100%'
        },
        padding: 8,
        formatter: formatter
    }
    return tooltip;
}

// 双轴tooltip
export function getDoubleAxisTooltip(unit: string = '') {
    let paramJsonObj = {
        trigger: "axis",
        transitionDuration: 0,
        appendToBody: true,
        confine: true, //是否将 tooltip 框限制在图表的区域内
        enterable: true,
        axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "line",
            snap: true,
            label: {
                show: true,
            }, // 默认为直线，可选为：'line' | 'shadow'
        },
        borderColor: "#7CB5EC",
        borderWidth: 1,
        backgroundColor: 'rgba(247, 247, 247, 0.85)',
        extraCssText: "box-shadow: 0 0 3px rgba(0, 0, 0, 0.3); borderRadius: 3; max-height: 400px;overflow: auto;font-size: 12px;",
        textStyle: {
            color: "#333333",
            fontSize: 12,
        },
        padding: 6,
        formatter: (params) => {
            let str = "";
            if (params.length > 0) {
                str += "<span>" + params[0].name + "<span><br/>";
                params.forEach((element) => {
                    if (isNil(element.data)) {
                        str += '<span style="display:inline-block;margin-right:5px;border-radius:8px;width:8px;height:8px;background-color:' + element.color + ';"></span>';
                        str += '<span style="color:' + element.color + ';">' + element.seriesName + "：</span> <b>" + "--" + " " + unit + "</b><br/>";
                    } else {
                        str += '<span style="display:inline-block;margin-right:5px;border-radius:8px;width:8px;height:8px;background-color:' + element.color + ';"></span>';
                        str += '<span style="color:' + element.color + ';">' + element.seriesName + "：</span> <b>" + element.data + " " + unit + "</b><br/>";
                    }
                });
            }
            return str;
        },
    }
    return paramJsonObj;
}

type trigger = 'item' | 'axis' | 'none';
// 箱线图tooltip
export function getBoxPlotTooltipOfAxisChart(tooltipUnit: string | string[] = "") {
    const boxPlotTooltip = {
        show: true,
        confine: true,
        // enterable: true,
        // appendToBody: true,
        trigger: 'axis' as trigger,
        axisPointer: getShadowAxisPointer(),
        borderColor: '#7CB5EC',
        borderWidth: 1,
        backgroundColor: 'rgba(247, 247, 247, 0.85)',
        extraCssText: 'box-shadow: 0 0 3px rgba(0, 0, 0, 0.3);border-radius:4px',
        textStyle: {
            color: "#333333",
            fontSize: 12
        },
        padding: 8,
        formatter: function (params) {
            let str = '';
            if (params.length > 0) {
                str = '<span>' + params[0].name + '</span><br/>'
                if (Array.isArray(tooltipUnit)) {
                    params.forEach((element, index) => {
                        if (element.seriesType === 'boxplot') {
                            // str += '<span style="color:' + element.color + '">' + element.marker + element.seriesName + ' </span> <br>';

                            element.encode.y.forEach(e => {
                                str += '<span style="color:' + element.color + '">' + element.dimensionNames[e] + ': </span>  <b>' + (element.data[e] == null ? '--' : element.data[e]) + '    ' + (tooltipUnit[0] ? tooltipUnit[0] : '') + '</b><br>'
                            });
                        } else if (element.seriesType === 'scatter') {
                            str += '<span style="color:' + element.color + '">' + '离散值' + ': </span> <b>' + (element.data[1] == null ? '--' : element.data[1]) + '    ' + (tooltipUnit[0] ? tooltipUnit[0] : '') + '</b><br>'
                        } else if (element.seriesType === 'line') {
                            str += '<span style="color:' + element.color + '">' + element.seriesName + ': </span>  <b>' + (element.data == null ? '--' : element.data) + '     ' + (tooltipUnit[1] ? tooltipUnit[1] : '') + '</b> <br>'
                        }
                    });
                } else {
                    params.forEach(element => {
                        // str += '<span style="color:' + element.color + '">' + element.marker + element.seriesName + '：</span> <b>' + element.value + ' ' + tooltipUnit + '</b><br/>'
                        if (element.seriesType === 'boxplot') {
                            // str += '<span style="color:' + element.color + '">' + element.marker + element.seriesName + ' </span> <br>';

                            element.encode.y.forEach(e => {
                                str += '<span style="color:' + element.color + '">' + element.dimensionNames[e] + ': </span>  <b>' + (element.data[e] == null ? '--' : element.data[e]) + ' ' + tooltipUnit + '</b><br>'
                            });
                        } else if (element.seriesType === 'scatter') {
                            str += '<span style="color:' + element.color + '">' + '离散值' + ': </span> <b>' + (element.data[1] == null ? '--' : element.data[1]) + ' ' + tooltipUnit + '</b><br>'
                        }

                    });
                }
            }
            return str;
        }
    }
    return boxPlotTooltip;
}
// 获取比较图的tooltip
export function getCompareCustomTooltipOfAxisChart(tooltipUnit: string = "", years: string[] = ['', '']) {
    const compareCustomTooltip = {
        show: true,
        confine: true,
        trigger: 'axis' as trigger,
        axisPointer: getShadowAxisPointer(),
        borderColor: '#7CB5EC',
        borderWidth: 1,
        backgroundColor: 'rgba(247, 247, 247, 0.85)',
        extraCssText: 'box-shadow: 0 0 3px rgba(0, 0, 0, 0.3);border-radius:4px',
        textStyle: {
            color: "#333333",
            fontSize: 12
        },
        padding: 8,
        formatter: function (param) {
            let str = '';

            str = '<span>' + param[0].name + '</span><br/>'
            if (years[0] === '' && years[0] === '') {
                for (const item of param) {
                    if (item.seriesType === "line") {
                        str += ` <span style="color:' + #77bef7 + '"> ${item.marker}  ${item.seriesName} </span> :<b> ${(item.value ? item.value : '--')} ${tooltipUnit} </b> <br>`;
                    } else if (item.seriesType === "custom") {
                        let label = +item.value[2] < 0 ? "减少" : "增加";
                        str += ` <span style="color: ${item.color}">  ${item.marker} ${label} :</span> <b> ${(item.value[2] ? item.value[2] : '--')} ${tooltipUnit} </b>`;
                    }
                }

            } else {
                for (const item of param) {
                    if (item.seriesType === "line") {
                        str += ` <span style="color: #77bef7 ">  ${years[1]}${item.seriesName} </span> :<b> ${(item.value ? item.value : '--')} ${tooltipUnit} </b> <br>`;
                    } else if (item.seriesType === "custom") {
                        str += ` <span style="color: #77bef7"> 对比${years[0]}增幅 :</span> <b> ${(item.value[2] ? item.value[2] : '--')} ${tooltipUnit} </b>`;
                    }
                }
            }
            return str;
        }
    }
    return compareCustomTooltip;
}
// 获取指数 仪表盘tooltip
export function getTooltipOfIndexGauge(detailText) {
    const compareCustomTooltip = {
        show: true,
        confine: true,
        borderColor: '#7CB5EC',
        borderWidth: 1,
        backgroundColor: 'rgba(247, 247, 247, 0.85)',
        extraCssText: 'box-shadow: 0 0 3px rgba(0, 0, 0, 0.3);border-radius:4px',
        textStyle: {
            color: "#333333",
            fontSize: 12
        },
        padding: 8,
        formatter: function (params) {
            let str = '';
            if (detailText.itemText !== '') {
                str = '<span>' + (detailText.itemText ? detailText.itemText : '--') + '</span><br/>';
            }
            str += params.seriesName + ':  <b>' + params.value + '</b><br/>';
            if (detailText.number !== '' && detailText.unit !== '') {
                str += '污染物浓度' + ': ' + ' <b>' + (!_.isNil(detailText.number) ? detailText.number : '--') + (!_.isNil(detailText.unit) ? detailText.unit : '') + '</b><br/>';
            }

            return str;
        }
    }
    return compareCustomTooltip;
}

// 获取散点图 tooltip
export function getTooltipOfScatter(tooltipUnit?: string[]) {
    const tooltipOfScatter = {
        show: true,
        confine: true,
        // enterable: true,
        // appendToBody: true,
        trigger: 'item' as trigger,
        axisPointer: getShadowAxisPointer(),
        borderColor: '#7CB5EC',
        borderWidth: 1,
        backgroundColor: 'rgba(247, 247, 247, 0.85)',
        extraCssText: 'box-shadow: 0 0 3px rgba(0, 0, 0, 0.3);border-radius:4px',
        textStyle: {
            color: "#333333",
            fontSize: 12
        },
        padding: 8,
        formatter: (params) => {
            let str = '';
            str = params.seriesName + '<br>'
            if (params.value && Array.isArray(params.value)) {
                params.value.forEach((e, i) => {
                    if (tooltipUnit) {
                        str += '<span style="color:' + params.color + '">' + params.marker + params.dimensionNames[i] + " : </span> <b>" + (e == null ? '--' : e) + ' ' + (tooltipUnit[i] ? tooltipUnit[i] : '') + '</b><br>'
                    } else {
                        str += '<span style="color:' + params.color + '">' + params.marker + params.dimensionNames[i] + " : </span> <b>" + (e == null ? '--' : e) + '</b><br>'
                    }
                });
            }

            // str += '<span style="color:' + params.color + '">' + params.marker + params.seriesName + '：</span> <b>' + params.value + tooltipUnit + '</b><br/>'
            return str;
        }
    }
    return tooltipOfScatter;
}

// 获取散点折线图 tooltip 
export function getTooltipOfScatterLine(tooltipUnit?: string[]) {
    const tooltipOfScatterLine = {
        show: true,
        confine: true,
        trigger: 'axis' as trigger,
        axisPointer: getCrossAxisPointer(),
        borderColor: '#7CB5EC',
        borderWidth: 1,
        backgroundColor: 'rgba(247, 247, 247, 0.85)',
        extraCssText: 'box-shadow: 0 0 3px rgba(0, 0, 0, 0.3);border-radius:4px',
        textStyle: {
            color: "#333333",
            fontSize: 12
        },
        padding: 8,
        formatter: (params) => {
            let str = '';
            str = '<span>' + params[0].value[0] + '</span><br/>';
            params.forEach((e, i) => {
                if (e.seriesType === 'line') {
                    if (tooltipUnit && Array.isArray(tooltipUnit) && tooltipUnit[1]) {
                        str += '<span style="color:' + e.color + '">' + e.marker + e.seriesName + " : </span> <b>" + (e.value[1] == null ? '--' : e.value[1]) + ' ' + (tooltipUnit[1] ? tooltipUnit[1] : '') + '</b><br>'
                    } else {
                        str += '<span style="color:' + e.color + '">' + e.marker + e.seriesName + " : </span> <b>" + (e.value[1] == null ? '--' : e.value[1]) + ' ' + '</b><br>'

                    }
                } else if (e.seriesType === 'scatter') {
                    e.value.forEach((item, index) => {
                        if (tooltipUnit && Array.isArray(tooltipUnit) && Array.isArray(tooltipUnit[0])) {
                            str += '<span style="color:' + e.color + '">' + e.marker + e.dimensionNames[index] + " : </span> <b>" + (item == null ? '--' : item) + ' ' + (tooltipUnit[0][index] ? tooltipUnit[0][index] : '') + '</b><br>'
                        } else {
                            str += '<span style="color:' + e.color + '">' + e.marker + e.dimensionNames[index] + " : </span> <b>" + (item == null ? '--' : item) + '</b><br>'
                        }
                    })
                }
            })
            return str;
        }
    }
    return tooltipOfScatterLine;
}

